import { render, staticRenderFns } from "./no_namespace_empty_state.vue?vue&type=template&id=759cd508"
import script from "./no_namespace_empty_state.vue?vue&type=script&lang=js"
export * from "./no_namespace_empty_state.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports